<div class="e-card view-card">
  <!-- Header -->
  <div class="detail-header">
    <div class="detail-header-left">
      <button type="button" class="e-btn e-flat" (click)="goBack()">
        <span class="ti ti-arrow-left icon-md"></span>
      </button>
      <div class="breadcrumb">
        @for (item of breadCrumbItems; track item.label; let last = $last) { @if
        (!last) {
        <a [routerLink]="item.routerLink" class="breadcrumb-link"
          >{{ item.label }}</a
        >
        <span class="breadcrumb-separator">›</span>
        } @else {
        <span class="breadcrumb-current"
          >{{ 'executionDetail' | translate }}</span
        >
        } }
      </div>
    </div>
  </div>

  <!-- Loading -->
  @if (isLoading()) {
  <div class="loading-state">
    <span class="ti ti-loader-2 spinning icon-xl"></span>
    <span>{{ 'loading' | translate }}</span>
  </div>
  }

  <!-- Content -->
  @if (!isLoading() && execution()) {
  <div class="detail-body">
    <!-- Status Banner -->
    @if (execution()!.jobExecutionLogStatus) {
    <div
      class="status-banner"
      [style.background-color]="execution()!.jobExecutionLogStatus!.bgColor"
      [style.color]="execution()!.jobExecutionLogStatus!.fgColor"
    >
      <span
        [class]="execution()!.jobExecutionLogStatus!.icon + ' banner-icon'"
      ></span>
      <span class="banner-status-name"
        >{{ execution()!.jobExecutionLogStatus!.name }}</span
      >
      <span class="banner-job-name"
        >— {{ execution()!.jobDefinition?.name }}</span
      >
    </div>
    }

    <!-- Info Grid -->
    <div class="info-grid">
      <!-- Left column -->
      <div class="info-section">
        <h4 class="section-title">{{ 'executionInfo' | translate }}</h4>

        <div class="info-row">
          <span class="info-label">{{ 'id' | translate }}</span>
          <span class="info-value mono">{{ execution()!.id }}</span>
        </div>

        <div class="info-row">
          <span class="info-label">{{ 'jobDefinition' | translate }}</span>
          <span class="info-value">
            <a
              [routerLink]="['/job-scheduler/definitions/form', execution()!.jobDefinitionId]"
              class="link"
            >
              {{ execution()!.jobDefinition?.name ||
              execution()!.jobDefinitionId }}
            </a>
          </span>
        </div>

        <div class="info-row">
          <span class="info-label">{{ 'attempt' | translate }}</span>
          <span class="info-value">{{ execution()!.attemptNumber }}</span>
        </div>

        @if (execution()!.bullJobId) {
        <div class="info-row">
          <span class="info-label">{{ 'bullJobId' | translate }}</span>
          <span class="info-value mono">{{ execution()!.bullJobId }}</span>
        </div>
        }

        <div class="info-row">
          <span class="info-label">{{ 'duration' | translate }}</span>
          <span class="info-value"
            >{{ formatDuration(execution()!.duration) }}</span
          >
        </div>

        @if (execution()!.progress != null) {
        <div class="info-row">
          <span class="info-label">{{ 'progress' | translate }}</span>
          <span class="info-value">
            <div class="progress-bar-container">
              <div
                class="progress-bar-fill"
                [style.width.%]="execution()!.progress"
                [class.progress-bar-fill--success]="execution()!.progress === 100"
              ></div>
              <span class="progress-label">{{ execution()!.progress }}%</span>
            </div>
          </span>
        </div>
        }
      </div>

      <!-- Right column -->
      <div class="info-section">
        <h4 class="section-title">{{ 'timeline' | translate }}</h4>

        <div class="info-row">
          <span class="info-label">{{ 'createdAt' | translate }}</span>
          <span class="info-value"
            >{{ execution()!.createdAt  | dateTz: 'medium' }}</span
          >
        </div>

        @if (execution()!.startedAt) {
        <div class="info-row">
          <span class="info-label">{{ 'startedAt' | translate }}</span>
          <span class="info-value"
            >{{ execution()!.startedAt  | dateTz: 'medium' }}</span
          >
        </div>
        } @if (execution()!.completedAt) {
        <div class="info-row">
          <span class="info-label">{{ 'completedAt' | translate }}</span>
          <span class="info-value success-text"
            >{{ execution()!.completedAt  | dateTz: 'medium' }}</span
          >
        </div>
        } @if (execution()!.failedAt) {
        <div class="info-row">
          <span class="info-label">{{ 'failedAt' | translate }}</span>
          <span class="info-value error-text"
            >{{ execution()!.failedAt  | dateTz: 'medium' }}</span
          >
        </div>
        }

        <!--<div class="info-row">
          <span class="info-label">{{ 'updatedAt' | translate }}</span>
          <span class="info-value"
            >{{ execution()!.updatedAt  | dateTz: 'medium' }}</span
          >
        </div>-->
      </div>
    </div>

    <!-- Result -->
    @if (execution()!.result) {
    <div class="code-section">
      <h4 class="section-title">
        <span class="ti ti-clipboard-check"></span>
        {{ 'result' | translate }}
      </h4>
      <pre class="code-block code-block--success">
{{ formatJson(execution()!.result) }}</pre
      >
    </div>
    }

    <!-- Error -->
    @if (execution()!.error) {
    <div class="code-section">
      <h4 class="section-title error-title">
        <span class="ti ti-alert-circle"></span>
        {{ 'error' | translate }}
      </h4>
      <div class="error-message">{{ execution()!.error }}</div>

      @if (execution()!.errorStack) {
      <details class="stack-details">
        <summary class="stack-summary">{{ 'stackTrace' | translate }}</summary>
        <pre class="code-block code-block--error">
{{ execution()!.errorStack }}</pre
        >
      </details>
      }
    </div>
    }
  </div>
  }

  <!-- Not found -->
  @if (!isLoading() && !execution()) {
  <div class="empty-state">
    <span class="ti ti-mood-sad icon-xl"></span>
    <p>{{ 'executionNotFound' | translate }}</p>
    <button type="button" class="e-btn e-primary" (click)="goBack()">
      {{ 'backToList' | translate }}
    </button>
  </div>
  }
</div>
